import React from "react";
import { api } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

export function RefundsTab({ refunds, reload }) {
  const setStatus = async (id, s) => {
    try { await api.patch(`/refunds/${id}?status_=${s}`); toast.success(`${s}`); reload(); }
    catch { toast.error("Failed"); }
  };
  return (
    <div className="bg-white border border-[#E5E0D8] rounded-2xl overflow-hidden" data-testid="refunds-table">
      {refunds.length === 0 && <p className="p-6 text-[#4A5C50]">No refund notices.</p>}
      {refunds.map((r) => (
        <div key={r.id} className="p-6 border-b border-[#E5E0D8] last:border-0 flex items-center gap-4">
          <div className="flex-1">
            <p className="font-medium mono text-sm">{r.requester_email}</p>
            <p className="text-sm mt-1 text-[#4A5C50]">{r.reason}</p>
            <p className="text-xs mono text-[#4A5C50] mt-2">{new Date(r.created_at).toLocaleString()} · card {r.card_id.slice(0, 8)}</p>
          </div>
          <span className={`text-[11px] uppercase tracking-widest px-2 py-1 rounded-full ${r.status === "approved" ? "bg-[#184A30]/10 text-[#184A30]" : r.status === "rejected" ? "bg-neutral-200 text-neutral-700" : "bg-[#D96C4A]/15 text-[#B04E2F]"}`}>{r.status}</span>
          {r.status === "pending" && (
            <div className="flex gap-2">
              <Button size="sm" className="rounded-lg bg-[#184A30] text-white" onClick={() => setStatus(r.id, "approved")}>Approve</Button>
              <Button size="sm" variant="outline" className="rounded-lg" onClick={() => setStatus(r.id, "rejected")}>Reject</Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
